import * as d3 from 'd3';

export interface D3DonutChartData {
  name: string;
  color: string;
  count: number;
}

export class D3DonutChart {
  protected radius: number;

  svg: any;

  constructor(
    public options: {
      selector: string;
      data: Map<string, D3DonutChartData>;
      height: number;
      width: number;
    },
  ) {
    this.radius = Math.min(this.options.width, this.options.height) / 2;

    this.svg = d3
      .select(this.options.selector)
      .append('svg')
      .attr('width', this.options.width)
      .attr('height', this.options.height)
      .append('g')
      .attr('transform', `translate(${this.options.width / 2}, ${this.options.height / 2})`);

    d3
      .select('#pie svg')
      .append('text');

    this.update(this.options.data);

  //   document.addEventListener('visibilitychange', () => {
  //     console.log(document.visibilityState);
  //     window.dispatchEvent(new Event('resize'));
  //  });
  }

  update(data?: Map<string, D3DonutChartData>) {
    data = data || this.options.data;

    let total = 0;
    const domain = [];
    const colors = [];

    for (const id in data) {
      if (data[id] && data[id].hasOwnProperty('count')) {
        domain.push(id);
        colors.push(data[id].color);
        total += data[id].count;
      }
    }

    const color = d3
      .scaleOrdinal()
      .domain(domain)
      .range(colors);

    const pie = d3
      .pie()
      .sort((a: any, b: any) => d3.ascending(a.key, b.key))
      .value((d: any) => {
        return d.value.count;
      });

    const arc = d3
      .arc()
      .innerRadius(this.radius - 60)
      .outerRadius(this.radius);

    const u = this.svg.selectAll('path').data(pie(<any> d3.entries(data)));

    u.enter()
      .append('path')
      .merge(u)
      .attr('d', <any> arc)
      .attr('fill', (d: any) => {
        return <any> color(d.data.key);
      })
      .attr('stroke', '#e2e2e2')
      .style('stroke-width', '1px');

    u.exit().remove();

    const v = this.svg.selectAll('text').data(pie(<any> d3.entries(data)));
    v.enter()
      .append('text')
      .merge(v)
      .attr('transform', (d: any) => {
        return `translate(${arc.centroid(d)})`;
      })
      .attr('dy', '.35em')
      .style('font', '10px sans-serif')
      .style('text-anchor', 'middle')
      .text((d: any) => {
        return Math.round((d.data.value.count / total) * 100) + '%';
      });

    v.exit().remove();
  }
}
